module.exports = __webpack_public_path__ + "static/media/about-section-bg.9e4c54bb.svg";